//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DatasetLogDetail',
  props: {
    items: {
      type: Object,
      default: null
    }
  },
  watch: {
    items: function items(val) {
      console.log(val);
    }
  },
  computed: {
    getObjectLength: function getObjectLength(obj) {
      var size = 0;
      for (var k in obj) {
        size++;
      }
      return size;
    }
  },
  methods: {}
};